export const asciiLogo = `
 █████╗ ██████╗ ██████╗ ███████╗███████╗███╗   ███╗██████╗ ██╗     ███████╗
██╔══██╗██╔══██╗██╔══██╗██╔════╝██╔════╝████╗ ████║██╔══██╗██║     ██╔════╝
███████║██████╔╝██████╔╝███████╗█████╗  ██╔████╔██║██████╔╝██║     █████╗
██╔══██║██╔═══╝ ██╔═══╝ ╚════██║██╔══╝  ██║╚██╔╝██║██╔══██╗██║     ██╔══╝
██║  ██║██║     ██║     ███████║███████╗██║ ╚═╝ ██║██████╔╝███████╗███████╗
╚═╝  ╚═╝╚═╝     ╚═╝     ╚══════╝╚══════╝╚═╝     ╚═╝╚═════╝ ╚══════╝╚══════╝
`;
